import { Grid } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import cx from "classnames";
import type { ReactElement } from "react";
import { DeletionAccountAlert } from "src/component/element/DeletionAccountAlert/DeletionAccountAlert";
import { Sidebar } from "src/layout/AppLayout/Sidebar";

import styles from "./PageMain.module.scss";

export const PageMain = ({ page }: { page: ReactElement }) => {
  const matche = useMediaQuery("(min-width: 768px)");

  return (
    <Grid className={styles.grid}>
      <Grid.Col
        span={matche ? 3 : 0}
        className={cx(styles.sidebar, styles.col)}
      >
        <Sidebar />
      </Grid.Col>
      <Grid.Col span={matche ? 9 : 12} className={styles.col}>
        <main className={styles.main}>
          <DeletionAccountAlert />
          {page}
        </main>
      </Grid.Col>
    </Grid>
  );
};
